import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../_actions";
import { Button, Modal, SelectInput } from "../../../_components";
import { userConstants } from "../../../_constants";
import "../css/move-data-modal.scss";

const kartablMenu = {
  1: {
    title: { fa: "دریافتی", en: "daryafti" },
    submenus: [
      {
        name: "taiedie",
        label: "کتابخانه دیجیتال",
      },
      {
        name: "dastor_kar",
        label: "دستور کار‌ها",
      },
      {
        name: "sessions",
        label: "صورت جلسه کمیته",
      },
      {
        name: "dastor_amal",
        label: "دستور العمل",
      },
      {
        name: "ravesh",
        label: "روش های اجرایی",
      },
      {
        name: "policy",
        label: "خط مشی",
      },
    ],
  },
  2: {
    title: { fa: "فرآیند", en: "process" },
    submenus: [
      {
        name: "flowchart",
        label: "فلوچارت فرآیند",
      },
    ],
  },
  3: {
    title: { fa: "برنامه ها", en: "program" },
    submenus: [
      {
        name: "suggestion",
        label: "پیشنهاد برنامه",
      },
      {
        name: "programs_confirmation",
        label: "تایید برنامه",
      },
    ],
  },
  4: {
    title: { fa: "چک لیست ایمنی بیمار", en: "psuc_checklist" },
    submenus: [],
  },
};

const kartablMenuOptions = Object.entries(kartablMenu).map(([key, value]) => ({
  name: +key,
  label: value.title.fa,
}));

const calcNumbersAround = () => {
  const currentYear = moment().jYear();
  const startYear = 1394;
  return Array.from(
    { length: currentYear + 10 - startYear + 1 },
    (_, i) => startYear + i
  ).map((year) => ({
    label: year.toString(),
    name: year.toString(),
  }));
};

export const MoveDataModal = ({
  onClose,
  formValues,
  onChangeForm,
  hospitalId,
  activeUserId,
  reset,
}) => {
  const dispatch = useDispatch();
  const globalStorage = useSelector((state) => state.globalStorage);
  const [users, setUsers] = useState(null);
  const [submenuOptions, setSubmenuOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(null);
  const activeMenu = formValues.menu?.name;
  const yearOptions = calcNumbersAround();

  useEffect(() => {
    activeMenu && setSubmenuOptions(kartablMenu[activeMenu].submenus);
    // eslint-disable-next-line
  }, [activeMenu]);

  useEffect(() => {
    dispatch(
      userActions.API(
        "get",
        `v1/search_user?hospital_id=${hospitalId}&query=`,
        null,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    )
      .then((res) => {
        setUsers(
          res.data.result.map((user) => ({
            label: `${user.fn} ${user.ln}${
              user.post ? `- (${user.post})` : ""
            }`,
            name: user.id,
          }))
        );
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
    // eslint-disable-next-line
  }, [globalStorage.year]);

  const submitMoveKartabl = async () => {
    const data = {
      from_user_id: activeUserId,
      to_user_id: formValues.newUser?.name,
      year: formValues.year?.name,
      menu: kartablMenu[activeMenu].title.en,
      submenu: formValues.submenu?.name,
    };

    setIsSubmitting(true);

    dispatch(
      userActions.API(
        "post",
        `v1/user/kartabl/move`,
        data,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    )
      .then((res) => {
        userActions.successToast("کارتابل با موفقیت منتقل شد");
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]))
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Modal
      isOpen={true}
      title="کپی اطلاعات"
      onClose={onClose}
      className="move_data_modal"
    >
      <SelectInput
        title="کاربر جدید"
        placeholder="کاربر جدید را مشخص کنید"
        onChange={(ob) => onChangeForm("newUser", ob)}
        value={{
          label: formValues.newUser?.label,
          name: formValues.newUser?.name,
        }}
        options={users}
        containerClassName="mt-3"
        required
      />
      <SelectInput
        title="منو"
        placeholder="منو را مشخص کنید"
        onChange={(ob) => onChangeForm("menu", ob)}
        value={{
          label: formValues.menu?.label,
          name: formValues.menu?.name,
        }}
        options={kartablMenuOptions}
        containerClassName="mt-3"
        required
      />
      <SelectInput
        title="زیر منو"
        placeholder="زیر منو را مشخص کنید"
        onChange={(ob) => onChangeForm("submenu", ob)}
        value={{
          label: formValues.submenu?.label,
          name: formValues.submenu?.name,
        }}
        options={submenuOptions}
        containerClassName="mt-3"
      />
      <SelectInput
        title="سال مبدا اطلاعات"
        placeholder="سال مبدا را مشخص کنید"
        onChange={(ob) => onChangeForm("year", ob)}
        value={{
          label: formValues.year?.label,
          name: formValues.year?.name,
        }}
        options={yearOptions}
        containerClassName="mt-3"
      />
      <div className="submit_parent">
        <Button
          isLoading={isSubmitting}
          className="submit_btn"
          onClick={submitMoveKartabl}
        >
          بروز رســانی
        </Button>
        <Button
          isLoading={isSubmitting}
          className="close_btn"
          variant="outlined"
          onClick={onClose}
        >
          انصراف
        </Button>
      </div>
    </Modal>
  );
};
